import { Form, FormGroup } from "react-bootstrap";
import FormLayout from "../../../../components/Layout/FormLayout";
import ReactInput from "../../../../components/Inputs/ReactInput";
import InputLable from "../../../../components/Inputs/InputLable";
import ReactCheckbox from "../../../../components/Inputs/ReactCheckBox";
import { useFormikContext } from "formik";

const ServiceFormContainer = ({ editData, apiHandler, counterListData }) => {
  const intialValues = {
    name: editData?.name || "",
    info: editData?.info || "",
    counterId: editData?.counterId || "",
    status: editData ? editData?.status : true,
    prefix: editData?.prefix || "",
  };

  return (
    <div>
      <FormLayout
        initialValues={intialValues}
        apiHandler={(val) => (apiHandler ? apiHandler(val) : null)}
      >
        <FormGroup>
          <InputLable title="Name" htmlFor="name" required />
          <ReactInput name="name" id="name" required />
        </FormGroup>

        <FormGroup className="mt-3">
          <InputLable title="Prefix" htmlFor="prefix" required />
          <ReactInput name="prefix" id="prefix" required />
        </FormGroup>

        <CounterListSelect counterListData={counterListData} />

        <FormGroup className="mt-3">
          <InputLable title="Info" htmlFor="info" />
          <ReactInput name="info" id="info" as="textarea" rows={3} />
        </FormGroup>

        {/* Flex container for checkboxes */}
        <div className="d-flex justify-content-end mt-3">
          <div className="">
            <FormGroup className="mt-3">
              <ReactCheckbox label="Active" name="status" id="status" />
            </FormGroup>
          </div>
        </div>
      </FormLayout>
    </div>
  );
};

export default ServiceFormContainer;

const CounterListSelect = ({ counterListData }) => {
  const { setFieldValue, values } = useFormikContext();
  return (
    <div>
      <FormGroup className="mt-3">
        <InputLable title="Counter" required />
        <Form.Select
          value={values.counterId}
          onChange={(e) => setFieldValue("counterId", e.target.value)}
        >
          <option value="">Select Counter</option>
          {counterListData?.map((item) => (
            <option value={item?.id}>{item?.name}</option>
          ))}
        </Form.Select>
      </FormGroup>
    </div>
  );
};
